/**
 * AgentProcessEditorView — route wrapper for the process editor
 * (/agent-processes/new and /agent-processes/:processId).
 */

import { useParams } from 'react-router-dom';
import { ProcessEditor } from '../components/agent-process/ProcessEditor';
import { useCatalogSubscription } from '../hooks/useCatalogSubscription';

export function AgentProcessEditorView() {
  useCatalogSubscription('agentProcesses');
  const { processId } = useParams<{ processId: string }>();

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <ProcessEditor processId={processId} />
    </div>
  );
}
